
export const matcherConstants = {
    SAGA_GET_SINGLE_ENTITY_MATCH: "SAGA_GET_SINGLE_ENTITY_MATCH",
    }

export const  sagaGetSingleEntityMatchAction = (customInput: string, validation?: boolean) => {
    return { 
        type: matcherConstants.SAGA_GET_SINGLE_ENTITY_MATCH,
        payload: { customInput, validation },
    }
}


